<template>
  <div>
    <div class="table_scrol">
      <div class="w-card__content content-hardcode mb3">
        <div class="filter-container mb3">
            <w-select
              class="mt4 filter-premis"
              :items="premis"
              item-value="id"
              item-label="nama"
              label="Premis"
              v-model="carian.premis_id"
              @input="getData"
            />

            <w-select
              class="mt4 filter-tahun"
              :items="senarai_tahun"
              item-value="value"
              item-label="label"
              label="Tahun"
              v-model="carian.tahun"
              @input="getData"
            />
          </div>
        <div class="cards-table-grid">
          <!-- Cards -->
          <div class="dashboard-grid">
            <div
              v-for="(card, index) in cards2"
              :key="index"
              class="card-box"
              @click="openDialog(index)"
            >
              <div class="card-content">
                <div class="card-text">
                  <h2 class="card-value">{{ formatNumber(card.jumlah) }}</h2>
                  <small 
                    class="card-subtitle" 
                    :class="[
                      'sub' + (index + 1), 
                      { 'with-highlight': !['Jumlah Premis', 'Purata Kebuntingan AI'].includes(card.keterangan) }
                    ]"
                  >
                    {{ card.keterangan }}
                  </small>
                </div>
                <div class="card-icon" :class="'bg' + (index + 1)">
                  <img src="/images/chart1.png" alt="chart" class="icon-img" />
                </div>
              </div>
            </div>
          </div>

          <div class="tables-stack">
            <div class="w-table-wrap modern-table">
              <div class="table-profil-scrol">
                <table class="w-table w-100">
                  <thead>
                    <tr class="table-header">
                      <th colspan="3" class="text-center">
                        <div class="header-column">
                          <span class="title">TEMU JANJI</span>
                          <span class="datetime">
                            📅 {{ currentDate }} | 🕒 {{ currentTime }}
                          </span>
                        </div>
                      </th>
                    </tr>
                    <tr class="table-subheader">
                      <th class="text-center">Tugas</th>
                      <th class="text-center">Tarikh Temu Janji</th>
                      <th class="text-center">Bilangan</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in tarikh_aiman" :key="index">
                      <td class="text-center">{{ row.Tugas }}</td>
                      <td class="text-center">{{ row.Tarikh }}</td>
                      <td class="text-center">{{ row.Bilangan }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Trend Chart -->
        <div class="trend-grid">
          <div class="trend-box">
            <w-select
              class="mt4"
              v-model="carian_tahun.bulan_tahun"
              :items="bulan_tahun"
              @input="getServis()"
            />
            <GChart
              type="LineChart"
              :data="d_servis.datas"
              :options="{
                title: 'Jumlah Servis AI',
                curveType: 'function',
                legend: { position: 'bottom' },
                chartArea: { left: 50, right: 20, top: 40, bottom: 60 },
                vAxis: {
                  viewWindow: { min: 0 },
                  format: '0'
                },
                series: {
                  0: { color: '#ef4444' }
                },
                tooltip: { isHtml: true, textStyle: { fontSize: 12, bold: false }, trigger: 'focus' }
              }"
            />
          </div>

          <div class="trend-box">
            <w-select
              class="mt4"
              v-model="carian_bulan.bulan_tahun"
              :items="bulan_tahun"
              @input="getAnak()"
            />
            <GChart
                type="LineChart"
                :data="d_anak.datas"
                :options="{
                  title: 'Jumlah Kelahiran Anak AI',
                  curveType: 'function',
                  legend: { position: 'bottom' },
                  chartArea: { left: 50, right: 20, top: 40, bottom: 60 },
                  vAxis: {
                    viewWindow: { min: 0 },
                    format: '0'
                  },
                  series: {
                    0: { color: '#06b6d4' }
                  },
                  tooltip: { isHtml: true, textStyle: { fontSize: 12, bold: false }, trigger: 'focus' }
                }"
              />
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog 1: Jumlah Ternakan -->
    <w-dialog
      v-model="dialog.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom"
    >
      <template #title>
        Jumlah Ternakan
      </template>

      <w-select
           class="mt4"
           outline
           :items="lkp_ternakanWithAll"  
           item-value="value"       
           item-label="label"      
           label="Jenis Ternakan *"
           v-model="selectedTernakanId"
           @input="Chart(lastItemData)"
           :loading="isLoadingTernakan"
         />
      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartJantina" 
            :options="getChartOptions('Jantina')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartJurusan" 
            :options="getChartOptions('Jurusan')"
          />
        </div>

        <div class="chart-box-full">
              <!-- Keterangan warna khusus untuk chart umur -->
              <div class="chart-umur-legend">
               <div class="legend-dot-item">
                  <span class="dot male-dot">●</span>
                  <span class="legend-label">Jantan</span>
                </div>
                <div class="legend-dot-item">
                  <span class="dot female-dot">●</span>
                  <span class="legend-label">Betina</span>
                </div>
              </div>
              
              <GChart 
                type="ColumnChart" 
                :data="chartUmur" 
                :options="getUmurChartOptions()"
              />
            </div>
      </div>

      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
      </template>
    </w-dialog>

    <!-- Dialog 2: Jumlah Premis -->
    <w-dialog 
      v-model="dialog1.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog1.persistent"
      :persistent-no-animation="dialog1.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom">
      <template #title>
        Jumlah Premis
      </template>

      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog1.show = false">TUTUP</w-button>
      </template>
    </w-dialog>

    <w-dialog 
      v-model="dialog2.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog2.persistent"
      :persistent-no-animation="dialog2.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom">
      <template #title>
        Bil Pensijilan Baka
      </template>

      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartJenisBaka" 
            :options="getChartOptions('Jenis Baka')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartJantina" 
            :options="getChartOptions('Jantina')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartStatus" 
            :options="getChartOptions('Status')"
          />
        </div>
      </div>

      <template #actions>
        <w-button style="..." @click="dialog2.show = false">TUTUP</w-button>
      </template>
    </w-dialog>

    
    <w-dialog 
      v-model="dialog3.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog3.persistent"
      :persistent-no-animation="dialog3.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom">
      <template #title>
        Jumlah Servis AI
      </template>

      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="ColumnChart" 
            :data="safeChartData(chartPremis, ['Premis', 'Jumlah'])" 
            :options="getColumnChartOptions('Premis')"
          />
        </div>
      </div>

      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog3.show = false">TUTUP</w-button>
      </template>
    </w-dialog>

    
    <w-dialog 
      v-model="dialog4.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog4.persistent"
      :persistent-no-animation="dialog4.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom">
      <template #title>
        Jumlah Servis PD
      </template>

      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="ColumnChart" 
            :data="safeChartData(chartPremis, ['Premis', 'Jumlah'])" 
            :options="getColumnChartOptions('Premis')"
          />
        </div>
      </div>
      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog4.show = false">TUTUP</w-button>
      </template>
    </w-dialog>

    <!-- Dialog 6: Jumlah Kelahiran Anak AI -->
    <w-dialog 
      v-model="dialog5.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog5.persistent"
      :persistent-no-animation="dialog5.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom">
      <template #title>
        Jumlah Kelahiran Anak AI
      </template>

      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="ColumnChart" 
            :data="safeChartData(chartPremis, ['Premis', 'Jumlah'])"
            :options="getColumnChartOptions('Premis')"
          />
        </div>
      </div>

      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog5.show = false">TUTUP</w-button>
      </template>
    </w-dialog>

    <!-- Dialog 7: Jumlah Kebuntingan AI -->
    <w-dialog 
      v-model="dialog6.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog6.persistent"
      :persistent-no-animation="dialog6.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom">
      <template #title>
        Jumlah Kebuntingan AI
      </template>

      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="ColumnChart" 
            :data="safeChartData(chartPremis, ['Premis', 'Jumlah'])"
            :options="getColumnChartOptions('Premis')"
          />
        </div>
      </div>

      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog6.show = false">TUTUP</w-button>
      </template>
    </w-dialog>

    <!-- Dialog 8: Jumlah Ternakan AI -->
    <w-dialog 
      v-model="dialog7.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog7.persistent"
      :persistent-no-animation="dialog7.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom">
      <template #title>
        Jumlah Ternakan AI
      </template>

      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="ColumnChart" 
            :data="safeChartData(chartPremis, ['Premis', 'Jumlah'])" 
            :options="getColumnChartOptions('Premis')"
          />
        </div>
      </div>

      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog7.show = false">TUTUP</w-button>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  props: {
    d_tahun: { type: [Array, Object], required: true },
    role_id : String
  },
  components: {
    GChart
  },
  data() {
    return {
      cards2: [],
      premis: [],
      lkp_ternakan: [],
      tugasan: [],
      currentTime: "",
      currentDate: "",
      selectedTernakanId: 0,
      lastItemData: null,
      isLoadingTernakan: false,
      chartServisAi: [["Tahun", "Jumlah"]],
      chartAnakAi: [["Tahun", "Jumlah"]],
      chartJenisBaka: [['Jenis Baka', 'Jumlah']], 
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog1: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog2: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog3: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog4: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog5: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog6: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog7: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      bulan_tahun:[
        {value: 2, label: "TAHUN"},
        {value: 1, label: "BULAN BAGI TAHUN SEMASA"},
      ],
      chartTernakan: [
        ['Umur Hari','Berat Kg','ADG'],
      ],
      chartBaka: [
        ['Umur Hari','Berat Kg'],
      ],
      chartJurusan: [
        ['Umur Hari','ADG'],
      ],
      chartPremis: [['Premis', 'Jumlah']], 
      senarai_tahun: Array.from({ length: 5 }, (_, index) => {
        const year = new Date().getFullYear() - index;
        return { value: year, label: String(year) };
      }),
      carian: { 
        premis_id: "", 
        tahun: new Date().getFullYear().toString()
      },
      carian_tahun :{bulan_tahun: 1},
      carian_bulan :{bulan_tahun: 1},
      d_servis: [],
      d_anak: [],
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
    lkp_ternakanWithAll() {
    // Data dari API sudah format {value, label}
    if (this.lkp_ternakan.length > 0) {
      // Cek jika item pertama sudah "Semua"
      const firstItem = this.lkp_ternakan[0];
      const isFirstItemAll = firstItem.value === 0 && firstItem.label === 'Semua';
      
      if (!isFirstItemAll) {
        // Tambahkan "Semua" dengan format yang sama
        return [
          { value: 0, label: 'Semua' }, 
          ...this.lkp_ternakan
        ];
      }
    }
    return this.lkp_ternakan;
  },
    isTabletLandscape() {
      // Deteksi iPad mini landscape
      return this.windowWidth >= 768 && this.windowWidth <= 1024 && window.innerHeight < 500;
    },
    isDesktop() {
      return this.windowWidth >= 1025;
    },
    dialogWidth() {
      if (this.isMobile) return '100%';
      if (this.isTabletLandscape) return '90%';
      return '70%'; // Lebih kecil untuk desktop
    },
    dialogMaxWidth() {
      if (this.isMobile) return '100%';
      if (this.isTabletLandscape) return '1000px';
      return '800px'; // Lebih kecil untuk desktop
    }
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    formatNumber(value) {
      if (value === null || value === undefined) return '0';
      const num = parseInt(value);
      return num.toLocaleString('en-MY'); 
    },
    getServis(){
      this.$zcomm.get(this.api_service + 'dashboard/dashboard-servis?ind='+this.carian_tahun.bulan_tahun+'&role_id='+this.role_id, {}).then(res => {
        this.d_servis = res
      })
    },
    getAnak(){
      this.$zcomm.get(this.api_service + 'dashboard/dashboard-anak?ind='+this.carian_bulan.bulan_tahun+'&role_id='+this.role_id, {}).then(res => {
        this.d_anak = res
      })
    },
    getTugasan(){
      this.$zcomm.get(this.api_service + 'dashboard/dashboard-tugasanaiman', {}).then(res => {
        this.tugasan = res
      })
    },
    getTarikhaiman(){
      this.$zcomm.get(this.api_service + 'dashboard/dashboard-tarikhaiman', {}).then(res => {
        this.tarikh_aiman = res
      })
    },
    async getPremis() {
      try {
        const res = await this.$zcomm.get(this.api_service + "lookup/premis", {});
        this.premis = res.data ?? res;
      } catch (e) {
        console.error("Gagal ambil premis:", e);
      }
    },
    async getData(item) {
      if (item === 1) {
        this.carian.tahun = new Date().getFullYear();
      }

      try {
        const res = await this.$zcomm.get(
          this.api_service +
          "daftar/dashboard_ternakan?tahun=" + this.carian.tahun +
          "&premis_id=" + (this.carian.premis_id ?? ""),
          {}
        );

        const data = res.data ?? res;

        if (Array.isArray(data)) {
          this.cards2 = data;
          this.lkp_ternakan =
            data.find(d => d.keterangan === "Jumlah Ternakan")?.lkp_ternakan ?? [];

          // --- Inisialisasi chart ---
          this.chartServisAi = [["Bulan", "Jumlah"]];
          this.chartAnakAi = [["Bulan", "Jumlah"]];

          // --- Servis AI ---
          const servisAi = data.find(d => d.keterangan === "Jumlah Servis AI");
          const groupedServis = {};
          if (servisAi && Array.isArray(servisAi.data)) {
            servisAi.data.forEach(row => {
              const bulan = parseInt(row.bulan, 10);
              if (!bulan) return;
              groupedServis[bulan] = (groupedServis[bulan] || 0) + 1;
            });
          }
          for (let i = 1; i <= 12; i++) {
            this.chartServisAi.push([this.formatBulan(i), groupedServis[i] || 0]);
          }

          // --- Anak AI ---
          const anakAi = data.find(d => d.keterangan === "Jumlah Kelahiran Anak AI");
          const groupedAnak = {};
          if (anakAi && Array.isArray(anakAi.data)) {
            anakAi.data.forEach(row => {
              const bulan = parseInt(row.bulan, 10);
              if (!bulan) return;
              groupedAnak[bulan] = (groupedAnak[bulan] || 0) + 1;
            });
          }
          for (let i = 1; i <= 12; i++) {
            this.chartAnakAi.push([this.formatBulan(i), groupedAnak[i] || 0]);
          }

        } else {
          this.cards2 = [];
          this.chartServisAi = [["Bulan", "Jumlah"]];
          this.chartAnakAi = [["Bulan", "Jumlah"]];
        }
      } catch (err) {
        console.error("Gagal ambil data dashboard:", err);
        this.cards2 = [];
        this.chartServisAi = [["Bulan", "Jumlah"]];
        this.chartAnakAi = [["Bulan", "Jumlah"]];
      }
    },
    safeChartData(data, headers) {
      // Cegah error: jika tidak ada data valid, tampilkan "Tiada Data"
      if (!data || data.length <= 1) {
        return [headers, ['Tiada Data', 0]]
      }

      // Pastikan semua value kedua bertipe angka
      const cleanData = data.map((row, i) => {
        if (i === 0) return row // header
        return [row[0], Number(row[1]) || 0]
      })
      return cleanData
    },
    items(row) {
      if (row.Tugas === 'Perkhidmatan AI') {
        window.location.href =
          window.route('art.semakan.index') +
          '?lkp_art_id=1&lkp_status_id=31';
      }

      if (row.Tugas === 'Perkhidmatan PD') {
        window.location.href =
          window.route('art.semakan.index') +
          '?lkp_art_id=2&lkp_status_id=31';
      }

      if (row.Tugas === 'Perkhidmatan ET') {
        window.location.href =
          window.route('art.semakan.index') +
          '?lkp_art_id=3&lkp_status_id=31';
      }
    },
    formatBulan(val) {
      const bulan = [
        "Jan", "Feb", "Mar", "Apr", "Mei", "Jun",
        "Jul", "Agu", "Sep", "Okt", "Nov", "Des"
      ];

      if (!val) return val;

      // numeric (misal "09" atau 9)
      if (!isNaN(val)) {
        const idx = parseInt(val, 10) - 1;
        return bulan[idx] || val;
      }

      // string nama bulan full
      const lower = val.toLowerCase();
      const map = {
        januari: "Jan", februari: "Feb", maret: "Mar", april: "Apr",
        mei: "Mei", juni: "Jun", juli: "Jul", agustus: "Agu",
        september: "Sep", oktober: "Okt", november: "Nov", desember: "Des"
      };
      return map[lower] || val;
    },
    updateDateTime() {
      const now = new Date();

      this.currentDate = now.toLocaleDateString("ms-MY", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      });

      this.currentTime = now.toLocaleTimeString("en-US", { 
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true 
      });
    },
    openDialog(index) {
  const card = this.cards2[index]; 
  this.lastItemData = card; 

  // Debugging untuk melihat struktur data
  // console.log('Card data:', card);
  // console.log('lkp_ternakan dari card:', card?.lkp_ternakan);
  
  // Pastikan lkp_ternakan terisi dengan benar
  if (card && card.lkp_ternakan && Array.isArray(card.lkp_ernakan)) {
    this.lkp_ternakan = [...card.lkp_ternakan];
  } else {
    // Jika tidak ada data, coba ambil dari API
    this.getLkpTernakan();
  }
  
  // Set default selection
  this.selectedTernakanId = 0; 

  // Tunggu sedikit agar dialog terbuka sempurna sebelum render chart
  this.$nextTick(() => {
    if (index === 0) {
      this.dialog1.show = false;
    } else if (index === 1) {
      this.Chart(card);         
      this.dialog.show = true;  
    } else if (index === 2) {
      this.ChartTulen(card); 
      this.dialog2.show = true; 
    } else if (index === 3) {
      this.ChartAi(card); 
      this.dialog3.show = true; 
    } else if (index === 8) {
      this.ChartPd(card);
      this.dialog4.show = true; 
    } else if (index === 5) {
      this.ChartAnak(card); 
      this.dialog5.show = true;
    } else if (index === 6) {
      this.ChartBunting(card);
      this.dialog6.show = true; 
    } else if (index === 4) {
      this.ChartTernakan(card);
      this.dialog7.show = true; 
    }
  });
},
async getLkpTernakan() {
    try {
      const res = await this.$zcomm.get(this.api_service + "lookup/ternakan", {});
      const data = res.data ?? res;
      this.lkp_ternakan = Array.isArray(data) ? data : [];
      console.log('Data lkp_ternakan dari API:', this.lkp_ternakan);
    } catch (error) {
      console.error("Gagal mengambil data ternakan:", error);
      this.lkp_ternakan = [];
    }
  },
    Chart(item) {
  const list = item?.data ?? [];
  let filtered = list;
  
  if (this.selectedTernakanId && this.selectedTernakanId !== 0) {
    filtered = list.filter(row => {
      // Cek dengan format yang sesuai
      const ternakanValue = row.lkp_ternakan?.value || row.lkp_ternakan?.id;
      return ternakanValue === this.selectedTernakanId;
    });
  }

  // reset chart
  this.chartBaka = [['Baka', 'Jumlah']];
  this.chartJurusan = [['Jurusan', 'Jumlah']];
  this.chartJantina = [['Jantina', 'Jumlah']];
  this.chartTernakan = [['Jenis', 'Jumlah']];
  
  // Update struktur chartUmur DENGAN ANNOTATION COLUMNS
  this.chartUmur = [
    ['Umur', 'Jantan', { role: 'annotation', type: 'string' }, 'Betina', { role: 'annotation', type: 'string' }]
  ];

  const bakaMap = {};
  const jurusanMap = {};
  const jantinaMap = {};
  const ternakanMap = {};
  
  const umurMap = {
     '≤ 6 Bulan': { jantan: 0, betina: 0 },
     '1 Tahun': { jantan: 0, betina: 0 },
     '1 Tahun 6 Bulan': { jantan: 0, betina: 0 },
     '2 Tahun': { jantan: 0, betina: 0 },
     '3 Tahun': { jantan: 0, betina: 0 },
     '4 Tahun': { jantan: 0, betina: 0 },
     '> 4 Tahun': { jantan: 0, betina: 0 }
   };


  filtered.forEach(row => {
    const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
    bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

    const jurusanNama = row.lkp_jurusan?.nama ?? 'Tidak Diketahui';
    jurusanMap[jurusanNama] = (jurusanMap[jurusanNama] || 0) + 1;

    const jantinaNama = row.jantina == 1 ? 'Jantan' : row.jantina == 2 ? 'Betina' : 'Tidak Diketahui';
    jantinaMap[jantinaNama] = (jantinaMap[jantinaNama] || 0) + 1;

    const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
    ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

    if (row.tarikh_lahir) {
      const lahir = new Date(row.tarikh_lahir);
      if (!isNaN(lahir)) {
        const now = new Date();
        const umurBulan =
          (now.getFullYear() - lahir.getFullYear()) * 12 +
          (now.getMonth() - lahir.getMonth());

        let range;
         if (umurBulan <= 6) range = '≤ 6 Bulan';
         else if (umurBulan <= 12) range = '1 Tahun';
         else if (umurBulan <= 18) range = '1 Tahun 6 Bulan';
         else if (umurBulan <= 24) range = '2 Tahun';
         else if (umurBulan <= 36) range = '3 Tahun';
         else if (umurBulan <= 48) range = '4 Tahun';
         else range = '> 4 Tahun';


        if (row.jantina == 1) {
          umurMap[range].jantan++;
        } else if (row.jantina == 2) {
          umurMap[range].betina++;
        }
      }
    }
  });

  Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
  Object.entries(jurusanMap).forEach(([nama, jumlah]) => this.chartJurusan.push([`${nama} (${jumlah})`, jumlah]));
  Object.entries(jantinaMap).forEach(([nama, jumlah]) => this.chartJantina.push([`${nama} (${jumlah})`, jumlah]));
  Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
  
  // Format data umur DENGAN ANNOTATIONS
  Object.entries(umurMap).forEach(([range, data]) => {
    this.chartUmur.push([
      range, 
      data.jantan, 
      data.jantan > 0 ? data.jantan.toString() : '', // Annotation untuk Jantan
      data.betina, 
      data.betina > 0 ? data.betina.toString() : ''  // Annotation untuk Betina
    ]);
  });
},
    ChartTulen(item) {
      const list = item.data ?? [];

      // Reset charts
      this.chartBaka = [['Baka', 'Jumlah']];
      this.chartJantina = [['Jantina', 'Jumlah']];
      this.chartTernakan = [['Jenis', 'Jumlah']];
      this.chartStatus = [['Status', 'Jumlah']];
      this.chartJenisBaka = [['Jenis Baka', 'Jumlah']]; // <-- Reset chart baru

      const bakaMap = {};
      const jantinaMap = {};
      const ternakanMap = {};
      const statusMap = {};
      const jenisBakaMap = {}; // <-- Map untuk Hybrid/Tulen

      list.forEach(row => {
        // Kira Baka
        const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
        bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

        // Kira Jantina
        const jantinaNama = row.jantina == 1 ? 'Jantan' : row.jantina == 2 ? 'Betina' : 'Tidak Diketahui';
        jantinaMap[jantinaNama] = (jantinaMap[jantinaNama] || 0) + 1;

        // Kira Ternakan
        const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
        ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

        // Kira Status
        const statusNama = row.lkp_status?.nama ?? 'Tidak Diketahui';
        statusMap[statusNama] = (statusMap[statusNama] || 0) + 1;

        // Kira Jenis Baka (Hybrid / Tulen)
        // Di dalam ChartTulen(item)
          let jenisBakaNama = 'Tidak Diketahui';
          if (row.lkp_jenis_baka?.nama) {
            jenisBakaNama = row.lkp_jenis_baka.nama;
          } else if (row.lkp_jenis_baka_id == 1) {
            jenisBakaNama = 'Hybrid';
          } else if (row.lkp_jenis_baka_id == 2) {
            jenisBakaNama = 'Tulen';
          }
        jenisBakaMap[jenisBakaNama] = (jenisBakaMap[jenisBakaNama] || 0) + 1;
      });

      // Masukkan ke dalam Chart Data
      Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
      Object.entries(jantinaMap).forEach(([nama, jumlah]) => this.chartJantina.push([`${nama} (${jumlah})`, jumlah]));
      Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
      Object.entries(statusMap).forEach(([nama, jumlah]) => this.chartStatus.push([`${nama} (${jumlah})`, jumlah]));
      Object.entries(jenisBakaMap).forEach(([nama, jumlah]) => this.chartJenisBaka.push([`${nama} (${jumlah})`, jumlah]));
    },
    ChartTernakan(item) {
      const list = item.data ?? [];

        this.chartBaka = [['Baka', 'Jumlah']];
        this.chartPremis = [['Premis', 'Jumlah']];
        this.chartTernakan = [['Jenis', 'Jumlah']];

        const bakaMap = {};
        const premisMap = {};
        const ternakanMap = {};

        list.forEach(row => {
          // Chart Baka
          const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
          bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

          // Chart Premis - gunakan premis_nama dari API
          const premisNama = row.premis_nama ?? 'Tidak Diketahui';
          premisMap[premisNama] = (premisMap[premisNama] || 0) + 1;

          // Chart Ternakan
          const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
          ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

          
        });

        // Convert maps to chart data
        Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
        Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
        Object.entries(premisMap).forEach(([nama, jumlah]) => this.chartPremis.push([nama, jumlah]));

      },
    ChartAnak(item) {
      const list = item.data ?? [];

        this.chartBaka = [['Baka', 'Jumlah']];
        this.chartPremis = [['Premis', 'Jumlah']];
        this.chartTernakan = [['Jenis', 'Jumlah']];

        const bakaMap = {};
        const premisMap = {};
        const ternakanMap = {};

        list.forEach(row => {
          // Chart Baka
          const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
          bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

          // Chart Premis - gunakan premis_nama dari API
          const premisNama = row.premis_nama ?? 'Tidak Diketahui';
          premisMap[premisNama] = (premisMap[premisNama] || 0) + 1;

          // Chart Ternakan
          const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
          ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

          
        });

        // Convert maps to chart data
        Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
        Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
        Object.entries(premisMap).forEach(([nama, jumlah]) => this.chartPremis.push([nama, jumlah]));

      },
    ChartBunting(item) {
      const list = item.data ?? [];

        this.chartBaka = [['Baka', 'Jumlah']];
        this.chartPremis = [['Premis', 'Jumlah']];
        this.chartTernakan = [['Jenis', 'Jumlah']];

        const bakaMap = {};
        const premisMap = {};
        const ternakanMap = {};

        list.forEach(row => {
          // Chart Baka
          const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
          bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

          // Chart Premis - gunakan premis_nama dari API
          const premisNama = row.premis_nama ?? 'Tidak Diketahui';
          premisMap[premisNama] = (premisMap[premisNama] || 0) + 1;

          // Chart Ternakan
          const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
          ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

          
        });

        // Convert maps to chart data
        Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
        Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
        Object.entries(premisMap).forEach(([nama, jumlah]) => this.chartPremis.push([nama, jumlah]));

      },
    ChartAi(item) {
        const list = item.data ?? [];

        this.chartBaka = [['Baka', 'Jumlah']];
        this.chartPremis = [['Premis', 'Jumlah']];
        this.chartTernakan = [['Jenis', 'Jumlah']];

        const bakaMap = {};
        const premisMap = {};
        const ternakanMap = {};

        list.forEach(row => {
          // Chart Baka
          const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
          bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

          // Chart Premis - gunakan premis_nama dari API
          const premisNama = row.premis_nama ?? 'Tidak Diketahui';
          premisMap[premisNama] = (premisMap[premisNama] || 0) + 1;

          // Chart Ternakan
          const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
          ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

          
        });

        // Convert maps to chart data
        Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
        Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
        Object.entries(premisMap).forEach(([nama, jumlah]) => this.chartPremis.push([nama, jumlah]));

      },
    getChartOptions(title) {
  // 1. Tambah 'Jenis Baka' dalam senarai
  const isPieChart = ['Jenis Ternakan', 'Jantina', 'Baka', 'Jurusan', 'Status', 'Jenis Baka', 'Kaedah Premis', 'Jenis Pengguna'].includes(title);
  
  const options = {
    title: title,
    titleTextStyle: {
      fontSize: this.isMobile ? 16 : 18,
      bold: true
    },
    chartArea: { 
      width: this.isMobile ? '85%' : '85%',
      height: this.isMobile ? '75%' : '80%',
      top: 50,
      left: this.isMobile ? 10 : 20,
      right: 10,
      bottom: this.isMobile ? 50 : 40
    }
  };
  
  if (isPieChart) {
    Object.assign(options, {
      legend: { 
        position: this.isMobile ? 'bottom' : 'right',
        textStyle: {
          fontSize: this.isMobile ? 11 : 13, 
          maxLines: 3
        },
        alignment: 'center',
      },
      pieSliceText: 'percentage',
      pieSliceTextStyle: {
        fontSize: this.isMobile ? 11 : 13,
        color: 'white',
        bold: true
      },
      tooltip: {
        isHtml: true,
        trigger: 'focus',
        showColorCode: true
      },
      sliceVisibilityThreshold: 0.01,
      is3D: false,
      pieHole: 0.4, // 2. Tukar ke 0.4 untuk efek Doughnut (berlubang)
      pieStartAngle: 15,
      backgroundColor: 'transparent',
      height: this.isMobile ? 250 : 320,
      // 3. Buang width: '75%' supaya ia auto-fit dengan baik
    });
  }
  
  return options;
},
    getColumnChartOptions(title, selectable = false) {
  const options = {
    title: title + (this.selectedNegeri ? ` (${this.selectedNegeri})` : ''),
    titleTextStyle: {
      fontSize: this.isMobile ? 16 : 20,
      bold: true
    },
    legend: { position: 'none' },
    hAxis: { 
      title: title,
      textStyle: {
        fontSize: this.isMobile ? 9 : 11,
        color: '#333'
      },
      slantedText: false, // Tetap lurus
      showTextEvery: 1,
      // Otomatis wrap berdasarkan panjang
      maxTextLines: 2, // Maksimal 2 baris
      allowContainerBoundaryTextCutoff: true,
      textPosition: 'out'
    }, 
    vAxis: { 
      title: 'Jumlah', 
      minValue: 0,
      format: '0',
      textStyle: {
        fontSize: this.isMobile ? 10 : 12
      },
      gridlines: {
        color: '#f0f0f0',
        count: 5
      }
    },
    chartArea: { 
      width: '85%',
      height: '70%',
      top: 50,
      left: 80,
      right: 20,
      bottom: 80 // Beri ruang lebih untuk label multi-baris
    },
    tooltip: { 
      isHtml: true,
      trigger: 'focus'
    },
    focusTarget: 'category',
    selectionMode: selectable ? 'single' : 'none',
    height: this.isMobile ? 450 : 550, // Tinggi lebih besar untuk label 2 baris
    animation: {
      startup: true,
      duration: 1000,
      easing: 'out'
    },
    enableInteractivity: true,
    bar: { 
      groupWidth: '50%'
    },
    isStacked: false,
    backgroundColor: 'transparent'
  };

  return options;
},
    getUmurChartOptions() {
  return {
    title: 'Umur Ternakan',
    titleTextStyle: {
      fontSize: this.isMobile ? 14 : 16,
      bold: true
    },
    legend: { 
      position: this.isMobile ? 'bottom' : 'right',
      textStyle: {
        fontSize: this.isMobile ? 11 : 12
      }
    },
    vAxis: { 
      title: 'Jumlah',
      textStyle: {
        fontSize: this.isMobile ? 10 : 11
      },
      minValue: 0,
      format: '0'
    },
    hAxis: { 
      title: 'Umur',
      textStyle: {
        fontSize: this.isMobile ? 10 : 11
      }
    },
    series: {
      0: { color: '#ef4444' }, // Jantan - Merah
      1: { color: '#3b82f6' }  // Betina - Biru
    },
    bar: { groupWidth: '60%' },
    isStacked: false,
    
    // ANNOTATIONS UNTUK DI ATAS BAR
    annotations: {
      textStyle: {
        fontSize: this.isMobile ? 9 : 10,
        color: '#1f2937', // Warna teks gelap
        bold: true,
        auraColor: 'white', // Background putih di belakang teks
        auraWidth: 2
      },
      alwaysOutside: true, // Annotation di luar bar
      highContrast: true,
      stem: {
        color: 'none',
        length: 0
      }
    },
    
    chartArea: { 
      width: this.isMobile ? '85%' : '90%', 
      height: this.isMobile ? '60%' : '70%',
      top: 40,
      left: this.isMobile ? 40 : 60,
      right: 20,
      bottom: this.isMobile ? 60 : 40
    },
    
    // Optional: styling tambahan untuk visibility
    backgroundColor: 'transparent',
    tooltip: { 
      isHtml: true,
      textStyle: { fontSize: 12 }
    },
    enableInteractivity: true,
    height: this.isMobile ? 320 : 380
  };
}
},
  mounted() {
    this.getData(1);
    this.getServis();
    this.getAnak();
    this.getPremis();
    this.getTugasan();
    this.updateDateTime();
    this.getTarikhaiman();
    this.getLkpTernakan();
    setInterval(this.updateDateTime, 1000);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>

/* ===== DASHBOARD LAYOUT ===== */
.cards-table-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
  margin-top: 24px;
  align-items: start;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

.tables-stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.trend-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

/* ===== CARD STYLES ===== */
.card-box {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  padding: 24px 20px;
  box-shadow: 
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  position: relative;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  align-items: center;
}

.card-box:hover {
  transform: translateY(-4px);
  box-shadow: 
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border-color: #cbd5e0;
}

.card-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--card-color, #3b82f6), transparent);
}

.card-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
}

.card-text {
  flex: 1;
  min-width: 0;
}

.card-value {
  font-size: 32px;
  font-weight: 800;
  margin: 0 0 6px 0;
  color: #1a202c;
  line-height: 1;
  letter-spacing: -0.025em;
}

.card-subtitle {
  font-size: 14px;
  color: #64748b;
  display: block;
  font-weight: 500;
  line-height: 1.4;
  margin: 0;
}

.card-subtitle.with-highlight {
  position: relative;
  padding-bottom: 8px;
}

.card-subtitle.with-highlight::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 40px;
  border-radius: 2px;
  background: var(--card-color, #3b82f6);
  transition: width 0.3s ease;
}

.card-box:hover .card-subtitle.with-highlight::after {
  width: 60px;
}

.card-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--card-color, #3b82f6);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.card-box:hover .card-icon {
  transform: scale(1.05);
  box-shadow: 0 8px 15px -3px rgba(0, 0, 0, 0.2);
}

.card-icon .icon-img {
  width: 26px;
  height: 26px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.filter-container {
  display: flex;
  gap: 16px; 
  align-items: center;
}

.filter-premis {
  flex: 2; 
}

.filter-tahun {
  flex: 2; 
}


@media (max-width: 768px) {
  .filter-container {
    flex-direction: column;
    gap: 0;
  }
}

/* Card Colors */
.card-box:nth-child(1) { --card-color: #3b82f6; }
.card-box:nth-child(2) { --card-color: #10b981; }
.card-box:nth-child(3) { --card-color: #f59e0b; }
.card-box:nth-child(4) { --card-color: #ef4444; }
.card-box:nth-child(5) { --card-color: #8b5cf6; }
.card-box:nth-child(6) { --card-color: #ec4899; }
.card-box:nth-child(7) { --card-color: #06b6d4; }
.card-box:nth-child(8) { --card-color: #84cc16; }
.card-box:nth-child(9) { --card-color: #f97316; }
.card-box:nth-child(10) { --card-color: #64748b; }

/* ===== CHART STYLES ===== */
.chart-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px; /* Increased gap */
  margin-top: 20px; /* Increased margin */
  max-height: 75vh; /* Increased height */
  overflow-y: auto;
  padding-right: 8px;
}

.chart-box {
  background: #fff;
  border-radius: 12px;
  padding: 20px; /* Increased padding */
  box-shadow: 0px 3px 8px rgba(0,0,0,0.1); /* Enhanced shadow */
  text-align: center;
  min-height: 320px; /* Increased minimum height */
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #e2e8f0;
  position: relative;
}

.chart-box-full {
  grid-column: 1 / -1;
  background: #fff;
  border-radius: 12px;
  padding: 24px; /* Increased padding */
  box-shadow: 0px 3px 8px rgba(0,0,0,0.1);
  text-align: center;
  min-height: 380px; /* Increased minimum height */
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #e2e8f0;
}


.chart-grid::-webkit-scrollbar {
  width: 6px;
}

.chart-grid::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.chart-grid::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.chart-grid::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.trend-box {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.1);
  border: 1px solid #e2e8f0;
}

/* ===== TABLE STYLES ===== */
.modern-table table {
  width: 100%;
  border-collapse: collapse;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #333;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.table-header {
  background: linear-gradient(90deg, #3b82f6, #3b82f6);
  color: white;
}

.table-header th {
  padding: 14px 16px;
}

.header-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
}

.header-column .title {
  font-size: 16px;
  font-weight: 600;
}

.header-column .datetime {
  font-size: 13px;
  font-weight: 400;
  opacity: 0.9;
}

.table-subheader {
  background: #f8fafc;
  font-weight: 500;
  color: #475569;
}

.table-subheader th {
  padding: 12px;
  border-bottom: 1px solid #e2e8f0;
}

tbody td {
  padding: 12px;
  border-bottom: 1px solid #f1f5f9;
}

tbody tr:hover {
  background: #f8fafc;
}

/* User table styling */
.table-container {
  max-height: 400px;
  overflow-y: auto;
  margin-top: 10px;
}

.user-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.user-table th,
.user-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.user-table th {
  background-color: #f8fafc;
  font-weight: 600;
  color: #374151;
}

.user-table tr:hover {
  background-color: #f8fafc;
}

.role-badge {
  display: inline-block;
  background: #3b82f6;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  margin: 2px;
  font-weight: 500;
}

/* ===== BUTTON STYLES ===== */
.btn-modern {
  background: linear-gradient(135deg, #4f46e5, #3b82f6);
  color: white;
  border: none;
  border-radius: 9999px;
  padding: 8px 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  font-size: 13px;
}

.btn-modern:hover {
  background: linear-gradient(135deg, #4338ca, #2563eb);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.btn-modern:active {
  transform: scale(0.95);
}

.reset-btn {
  font-size: 11px !important;
  padding: 4px 10px !important;
}

/* ===== DIALOG STYLES ===== */
.dialog-content-custom {
  padding: 24px !important; /* Increased padding */
  max-height: 90vh !important; /* Increased max height */
  overflow-y: auto !important;
}

/* Tambahkan class khusus untuk dialog dengan chart */
.w-dialog--fullscreen {
  background: white;
}

.w-dialog__content {
  display: flex;
  flex-direction: column;
}

/* Styling untuk chart container */
.chart-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Full height untuk Google Chart */
.google-visualization-chart {
  flex: 1;
  min-height: 300px;
}

.selected-negeri {
  font-size: 14px;
  opacity: 0.8;
  font-weight: normal;
  margin-left: 8px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 0 8px;
}

/* ===== CHART LEGEND STYLES ===== */
.chart-umur-legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 12px;
  padding: 8px;
}

.legend-dot-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dot {
  font-size: 16px;
}

.female-dot {
  color: #3b82f6;
}

.male-dot {
  color: #ef4444;
}

.legend-label {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

.selectable-chart {
  cursor: pointer;
}

.selectable-chart:hover {
  opacity: 0.9;
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 1024px) {
  .cards-table-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .dashboard-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 14px;
  }
  
  .card-box {
    padding: 20px 16px;
    min-height: 110px;
  }
  
  .card-value {
    font-size: 28px;
  }
  
  .card-icon {
    width: 50px;
    height: 50px;
  }
  
  .card-icon .icon-img {
    width: 24px;
    height: 24px;
  }
  
  .chart-box {
    min-height: 260px;
  }
  
  .chart-box-full {
    min-height: 300px;
  }
}

@media (max-width: 768px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .trend-grid {
    grid-template-columns: 1fr;
  }
  
  .chart-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .chart-grid-mobile .chart-box {
    min-height: 240px;
  }
  
  .chart-grid-mobile .chart-box-full {
    min-height: 280px;
  }
  
  .card-box {
    padding: 18px 14px;
    min-height: 100px;
  }
  
  .card-value {
    font-size: 26px;
  }
  
  .card-subtitle {
    font-size: 13px;
  }
  
  .card-icon {
    width: 44px;
    height: 44px;
  }
  
  .card-icon .icon-img {
    width: 22px;
    height: 22px;
  }
  
  .chart-umur-legend {
    gap: 15px;
  }
  
  .legend-dot-item {
    gap: 4px;
  }
  
  .dot {
    font-size: 14px;
  }
  
  .legend-label {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .card-content {
    gap: 12px;
  }
  
  .card-box {
    padding: 16px 12px;
    min-height: 90px;
  }
  
  .card-value {
    font-size: 24px;
  }
  
  .card-icon {
    width: 40px;
    height: 40px;
  }
  
  .card-icon .icon-img {
    width: 20px;
    height: 20px;
  }
  
  .trend-grid {
    gap: 16px;
    margin-top: 24px;
  }
  
  .trend-box {
    padding: 16px;
  }
}

/* Tablet landscape adjustments */
@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .table_scrol {
    max-height: 85vh;
    overflow-y: auto;
  }
  
  .card-box {
    padding: 16px 12px;
    min-height: 90px;
  }
  
  .card-value {
    font-size: 26px;
  }
  
  .chart-box {
    padding: 12px;
    min-height: 220px;
  }
  
  .chart-box-full {
    padding: 12px;
    min-height: 260px;
  }
  
  .trend-box {
    padding: 16px;
    min-height: 240px;
  }
}

/* Animation for card appearance */
@keyframes cardAppear {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-box {
  animation: cardAppear 0.5s ease-out forwards;
}

/* Stagger animation for multiple cards */
.card-box:nth-child(1) { animation-delay: 0.1s; }
.card-box:nth-child(2) { animation-delay: 0.2s; }
.card-box:nth-child(3) { animation-delay: 0.3s; }
.card-box:nth-child(4) { animation-delay: 0.4s; }
.card-box:nth-child(5) { animation-delay: 0.5s; }
.card-box:nth-child(6) { animation-delay: 0.6s; }
.card-box:nth-child(7) { animation-delay: 0.7s; }
.card-box:nth-child(8) { animation-delay: 0.8s; }
.card-box:nth-child(9) { animation-delay: 0.9s; }
.card-box:nth-child(10) { animation-delay: 1s; }

/* ===== FIX TOOLTIP GOOGLE CHART ===== */
.trend-box ::v-deep svg g text {
  letter-spacing: normal !important;
  word-spacing: normal !important;
}

.trend-box ::v-deep svg {
  overflow: visible !important;
}

.trend-box ::v-deep .google-visualization-tooltip {
  width: auto !important;
  min-width: 90px;
  white-space: nowrap;
  line-height: 1.4;
  padding: 6px 10px;
  z-index: 10;
}

.trend-box ::v-deep .google-visualization-tooltip-item,
.trend-box ::v-deep .google-visualization-tooltip-item span {
  white-space: nowrap;
  font-size: 12px;
  line-height: 1.4;
}

.trend-box ::v-deep .google-visualization-tooltip-item-list {
  margin: 0;
  padding: 0;
}

.trend-box {
  overflow: visible;
}
</style>